export default __webpack_public_path__ + "static/media/Diviner's Gloves of Secret Doors.7cf9df0d.jpg";